<template>
  <!-- 复制弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_RoleSelection')"
    width="260px"
    :close-on-click-modal="false"
  >
    <div style="margin-left: 10px;">
      <el-checkbox-group v-model="selectedPositions">
        <div
          v-for="position in positionCasts"
          :key="position.code"
          style="display: flex; flex-direction: row;align-items: center"
        >
          <el-checkbox :label="position.code" style="margin-top: 8px;margin-bottom: 8px;word-wrap: break-word;white-space: normal;word-break:normal;display: flex;flex-direction: row;justify-content: center">
            <span style="font-size: 12px">{{ position.chineseName }}</span>
          </el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { POSITION_CASTS } from '@/class/cargo/model/parameters/WorkflowConstants'

export default {
  name: 'ChooseCastDialog',
  components: { },
  props: {
    values: {
      type: Array,
      default: () => []
    },
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      innerVisible: false,
      positionCasts: POSITION_CASTS,
      selectedPositions: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      if (this.values && this.values.length > 0) {
        this.selectedPositions = [...this.values]
      }
    },
    enterHandler() {
      this.selectedPositions = this.selectedPositions.filter(item => item != null && item !== '' && item !== 0)
      console.log('selectedPositions', this.selectedPositions)
      this.$emit('change', this.selectedPositions)
    },
    confirmCallBack() {
      this.$emit('confirmCallBack')
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
